export default __webpack_public_path__ + "static/media/img2.c187a1d7.jpg";